<script setup>
import * as fancybox from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

const { Fancybox } = fancybox;
onMounted(() => {
  Fancybox.bind("[data-fancybox='gallery']", {
    Image: {
      zoom: false,
      wheel: "slide",
      hideScrollbar: false,
    },
  });
});

const { $get } = useAxios();

const route = useRoute();

const { data: album, pending: isLoaded } = await useAsyncData(
  `get album by id ${route.params.id}`,
  () => $get(`/api/v3/albums/${route.params.id}`)
);

const participants = computed(() => {
  let _participants = [];
  try {
    if (album.value) {
      let stringName = "";
      album.value.photos.forEach((element) => {
        stringName = "На фото: ";
        if (!element.participants.length) {
          stringName = "";
        } else {
          const lengthArray = element.participants.length - 1;
          element.participants.forEach((elem, index) => {
            if (lengthArray === index) {
              stringName += `${elem.name}.`;
            } else {
              stringName += `${elem.name}, `;
            }
          });
        }
        _participants.push(stringName);
      });
    }
  } catch (error) {}
  return _participants;
});

useHead(
  computed(() => {
    if (album.value) {
      return {
        title: `${album.value?.name} | Государственный русский театр драмы им. Ф. А. Искандера`,
        meta: [
          {
            hid: "title",
            property: "title",
            content: `${album.value?.name} | Государственный русский театр драмы им. Ф. А. Искандера`,
          },
          {
            hid: "og:title",
            property: "og:title",
            content: `${album.value?.name} | Государственный русский театр драмы им. Ф. А. Искандера`,
          },
          {
            hid: "url",
            name: "url",
            content: `https://rusdram.org/media/photos/${album.value?._id}`,
          },
          {
            hid: "og:url",
            property: "og:url",
            content: `https://rusdram.org/media/photos/${album.value?._id}`,
          },
          {
            hid: "image",
            name: "image",
            content: `https://ucarecdn.com/${album.value?.photos[0].fileKey}/-/quality/smart/image.png`,
          },
          {
            name: "og:image",
            property: "og:image",
            content: `https://ucarecdn.com/${album.value?.photos[0].fileKey}/-/quality/smart/image.png`,
          },
        ],
      };
    } else {
      return {
        title: `Русдрам`,
      };
    }
  })
);
</script>

<template>
  <nuxt-layout name="default">
    <div v-if="!isLoaded">
      <div class="container px-4 xl:px-0">
        <RBack></RBack>
      </div>
      <r-section v-if="album" :title="album.name" class="mt-5">
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-7">
          <div
            v-for="(photo, index) in album.photos"
            :key="photo.fileKey"
            class="rounded-lg overflow-hidden aspect-w-4 aspect-h-3 flex"
            :class="[
              index === 0
                ? 'xl:col-start-1 xl:col-end-3 xl:row-start-1 xl:row-end-3'
                : '',
            ]"
          >
            <img
              data-fancybox="gallery"
              :href="`https://ucarecdn.com/${photo.fileKey}/img.png`"
              class="object-cover w-full h-full cursor-pointer text-xl"
              :data-caption="participants[index]"
              loading="lazy"
              :src="`https://ucarecdn.com/${photo.fileKey}/-/format/auto/-/quality/smart/image.png`"
            />
          </div>
        </div>
      </r-section>
    </div>
    <r-full-page-pro-loader v-else></r-full-page-pro-loader>
  </nuxt-layout>
</template>
